import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';
const useInterval = (callback, delay) => {
  const intervalId = React.useRef(null);
  const savedCallback = React.useRef(callback);

  React.useEffect(() => {
    savedCallback.current = callback;
  });

  React.useEffect(() => {
    const tick = () => savedCallback.current();

    if (typeof delay === 'number') {
      intervalId.current = window.setInterval(tick, delay);

      return () => window.clearInterval(intervalId.current);
    }
  }, [delay]);

  return intervalId.current;
};

const StepsComponent = props => {
  const {
    GetAirtime,
    GetTraction,
    BuildTrust,
    WinBuy,
    StreamlineApproval,
    DeliverRoiWithCertainty,
    customer,
    isChangeLeader,
  } = props;

  const tabsImaged = {
    0: {
      Comment: (
        <div
          className={` ${isChangeLeader ? 'steps-section-changeLeader' : ''}`}
        >
          <GatsbyImage
            alt={''}
            image={GetAirtime}
            className={`steps-section-image ${
              isChangeLeader ? 'steps-section-image-changeLeader' : ''
            }`}
          />
          {isChangeLeader && (
            <div className="steps-section-rectangle">
              <p className="steps-section-rectangle-text">
                “Agreed helped me bridge the gap between ideas and results by
                socializing the great work from our innovation culture to the
                operating realities of our business.”
              </p>
              <div className="steps-section-rectangle-wrapper">
                <div>
                  <p className="steps-section-rectangle-question">
                    Ready to see how Agreed helps you win?
                  </p>
                  <p className="steps-section-rectangle-question-bold">
                    Request a live demo today.
                  </p>
                </div>
                <Link
                  className="steps-section-rectangle-wrapper-button"
                  to="/contact"
                >
                  Contact Sales
                </Link>
              </div>
            </div>
          )}
        </div>
      ),
    },

    1: {
      Comment: (
        <div
          className={` ${isChangeLeader ? 'steps-section-changeLeader' : ''}`}
        >
          <GatsbyImage
            alt={''}
            image={GetTraction}
            className={`steps-section-image ${
              isChangeLeader ? 'steps-section-image-changeLeader' : ''
            }`}
          />
          {isChangeLeader && (
            <div className="steps-section-rectangle">
              <p className="steps-section-rectangle-text">
                “Agreed gave our executive team a huge confidence boost that our
                transformation efforts will actually work. We love the
                visibility and accountability of having stakeholders on the
                platform.“
              </p>
              <div className="steps-section-rectangle-wrapper">
                <div>
                  <p className="steps-section-rectangle-question">
                    Ready to see how Agreed helps you win?
                  </p>
                  <p className="steps-section-rectangle-question-bold">
                    Request a live demo today.
                  </p>
                </div>
                <Link
                  className="steps-section-rectangle-wrapper-button"
                  to="/contact"
                >
                  Contact Sales
                </Link>
              </div>
            </div>
          )}
        </div>
      ),
    },

    2: {
      Comment: (
        <div
          className={` ${isChangeLeader ? 'steps-section-changeLeader' : ''}`}
        >
          <GatsbyImage
            alt={''}
            image={BuildTrust}
            className={`steps-section-image ${
              isChangeLeader ? 'steps-section-image-changeLeader' : ''
            }`}
          />
          {isChangeLeader && (
            <div className="steps-section-rectangle">
              <p className="steps-section-rectangle-text">
                “Launching a project with everybody aligned at the beginning
                feels like a dream come true. Literally, Agreed is a dream come
                true because it gets everyone on board.“
              </p>
              <div className="steps-section-rectangle-wrapper">
                <div>
                  <p className="steps-section-rectangle-question">
                    Ready to see how Agreed helps you win?
                  </p>
                  <p className="steps-section-rectangle-question-bold">
                    Request a live demo today.
                  </p>
                </div>
                <Link
                  className="steps-section-rectangle-wrapper-button"
                  to="/contact"
                >
                  Contact Sales
                </Link>
              </div>
            </div>
          )}
        </div>
      ),
    },

    3: {
      Comment: (
        <div
          className={` ${isChangeLeader ? 'steps-section-changeLeader' : ''}`}
        >
          <GatsbyImage
            alt={''}
            image={WinBuy}
            className={`steps-section-image ${
              isChangeLeader ? 'steps-section-image-changeLeader' : ''
            }`}
          />
          {isChangeLeader && (
            <div className="steps-section-rectangle">
              <p className="steps-section-rectangle-text">
                “I love that Agreed gives me a little bit of peer pressure
                leverage that helps move initiatives along and highlight where
                (and who) the roadblocks are, especially when I’m dealing with
                senior leadership in every department.“
              </p>
              <div className="steps-section-rectangle-wrapper">
                <div>
                  <p className="steps-section-rectangle-question">
                    Ready to see how Agreed helps you win?
                  </p>
                  <p className="steps-section-rectangle-question-bold">
                    Request a live demo today.
                  </p>
                </div>
                <Link
                  className="steps-section-rectangle-wrapper-button"
                  to="/contact"
                >
                  Contact Sales
                </Link>
              </div>
            </div>
          )}
        </div>
      ),
    },

    4: {
      Comment: (
        <div
          className={` ${isChangeLeader ? 'steps-section-changeLeader' : ''}`}
        >
          <GatsbyImage
            alt={''}
            image={StreamlineApproval}
            className={`steps-section-image ${
              isChangeLeader ? 'steps-section-image-changeLeader' : ''
            }`}
          />
          {isChangeLeader && (
            <div className="steps-section-rectangle">
              <p className="steps-section-rectangle-text">
                “Agreed is my favorite! It’s like Agreed is my clone for
                socializing, gathering feedback, and following up with a
                plethora of stakeholders.“
              </p>
              <div className="steps-section-rectangle-wrapper">
                <div>
                  <p className="steps-section-rectangle-question">
                    Ready to see how Agreed helps you win?
                  </p>
                  <p className="steps-section-rectangle-question-bold">
                    Request a live demo today.
                  </p>
                </div>
                <Link
                  className="steps-section-rectangle-wrapper-button"
                  to="/contact"
                >
                  Contact Sales
                </Link>
              </div>
            </div>
          )}
        </div>
      ),
    },
    5: {
      Comment: (
        <div
          className={` ${isChangeLeader ? 'steps-section-changeLeader' : ''}`}
        >
          <GatsbyImage
            alt={''}
            image={DeliverRoiWithCertainty}
            className={`steps-section-image ${
              isChangeLeader ? 'steps-section-image-changeLeader' : ''
            }`}
          />
          {isChangeLeader && (
            <div className="steps-section-rectangle">
              <p className="steps-section-rectangle-text">
                “Agreed gives me a better view into the initiatives that have
                historically been on everybody’s personal desktop. New, we can
                accelerate our strategic plan with projects that we didn’t even
                know about before.“
              </p>
              <div className="steps-section-rectangle-wrapper">
                <div>
                  <p className="steps-section-rectangle-question">
                    Ready to see how Agreed helps you win?
                  </p>
                  <p className="steps-section-rectangle-question-bold">
                    Request a live demo today.
                  </p>
                </div>
                <Link
                  className="steps-section-rectangle-wrapper-button"
                  to="/contact"
                >
                  Contact Sales
                </Link>
              </div>
            </div>
          )}
        </div>
      ),
    },
    6: {
      Comment: (
        <div
          className={` ${isChangeLeader ? 'steps-section-changeLeader' : ''}`}
        >
          <GatsbyImage
            alt={''}
            image={customer}
            className={`steps-section-image ${
              isChangeLeader ? 'steps-section-image-changeLeader' : ''
            }`}
          />
          {isChangeLeader && (
            <div className="steps-section-rectangle">
              <p className="steps-section-rectangle-text">
                “Agreed helps me socialize CX insights in a way that
                productively engages other teams and highlights the benefits for
                everyone.“
              </p>
              <div className="steps-section-rectangle-wrapper">
                <div>
                  <p className="steps-section-rectangle-question">
                    Ready to see how Agreed helps you win?
                  </p>
                  <p className="steps-section-rectangle-question-bold">
                    Request a live demo today.
                  </p>
                </div>
                <Link
                  className="steps-section-rectangle-wrapper-button"
                  to="/contact"
                >
                  Contact Sales
                </Link>
              </div>
            </div>
          )}
        </div>
      ),
    },
  };
  const [readMore, setReadMore] = useState(false);
  const { listItem } = props;
  const [isActive, setIsActive] = useState(0);
  // const intervalRef = useRef(null);
  const activeText = () => {
    if (isActive === listItem.length - 1) {
      return setIsActive(0);
    }
    return setIsActive((prev) => prev + 1);
  };

  const [status, setStatus] = React.useState('idle');
  const [timeElapsed, setTimeElapsed] = React.useState(0);

  useInterval(
    () => {
      setTimeElapsed(timeElapsed => timeElapsed + 1);
      if (timeElapsed === 4) {
        activeText()
        setTimeElapsed(0);
      }
    },
    status === 'running' ? 2100 : null
  );

  const pause = () => {
    setTimeElapsed(0);
    setStatus('idle');
  };

  const resume = () => {
    setTimeElapsed(0);
    setStatus('running');
  }

  useEffect(() => {
    resume()
  }, [isActive]);


  return (
    <div className="full-container">
      <div className="steps-section">
        <div className="row">
          <div className="col-md-4">
            {isChangeLeader && (
              <p className="steps-section-changeLeader-title">
                Successful initiatives just got a lot easier.
              </p>
            )}
            <div className="carosel-test">
              <ul onMouseOver={pause}  onMouseOut={resume}>
                {listItem &&
                  listItem.map((item, index) => {
                    return (
                      <li key={index} onClick={() => setIsActive(index)}>
                        {isActive === index && (
                          <div className={`progress--bar-base`}>
                            <div className={`progress--bar-filling`}></div>
                            <div className={`progress-bar`}></div>
                          </div>
                        )}
                        <button
                          className={`steps-section-button ${
                            index === isActive
                              ? 'steps-section-button-active'
                              : ''
                          }`}
                          onClick={() => setIsActive(index)}
                          role="button"
                        >
                          <span
                            className={`steps-section-button-title ${
                              index === isActive
                                ? 'steps-section-button-title-active'
                                : ''
                            }`}
                          >
                            {item.title}
                          </span>
                          {index === isActive && (
                            <span>
                              <a
                                role="button"
                                aria-label="tabs"
                                className="steps-section-button-description"
                                onClick={() => {
                                  setReadMore([readMore]);
                                }}
                              >
                                <span className="steps-section-button-description-text">
                                  {item.subtitle}
                                </span>
                                <span>{item.description}</span>
                                <span>{item.subDescription}</span>
                              </a>
                              <span className="steps-section-mobile-image">
                                <img
                                alt='stepsImage'
                                  src={item.image}
                                  style={{ width: '100%' }}
                                />
                              </span>
                              {isChangeLeader && (
                                <span className="steps-section-mobile-image">
                                  {item.text}
                                </span>
                              )}
                            </span>
                          )}
                        </button>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
          <div
            className={`col-md-8 ${
              isChangeLeader ? 'col-md-8 steps-section-changeLeader-col' : ''
            }`}
          >
            <div className="steps-section-image">
              {tabsImaged[isActive].Comment}
            </div>
            <div className={`steps-section-pagination ${isChangeLeader ? 'steps-section-pagination-changeleader' : ''}`}>
              <ul className="steps-section-pagination-list">
                {listItem &&
                  listItem.map((item, index) => {
                    return (
                      <li
                        key={index}
                        className="steps-section-pagination-list-item"
                      >
                        <button
                        role="button"
                          aria-label="list"
                          className={`steps-section-pagination-item ${
                            index === isActive
                              ? 'steps-section-pagination-item-active'
                              : ''
                          }`}
                          onClick={() => {
                            setIsActive(index);
                          }}
                        ></button>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default StepsComponent;
